// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  padding: 2rem;
  background: #f8fafc;
  min-height: calc(100vh - 70px);
  width: 100%;
  box-sizing: border-box;
}

.settings-header {
  margin-bottom: 2rem;
}

.settings-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem 0;
}

.settings-header p {
  color: #6b7280;
  margin: 0;
}

.settings-content {
  display: flex;
  gap: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 100%;
}

.settings-sidebar {
  width: 250px;
  background: #f9fafb;
  border-right: 1px solid #e5e7eb;
}

.settings-nav {
  padding: 1rem 0;
}

.settings-nav-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1.5rem;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
}

.settings-nav-item:hover {
  background: #f3f4f6;
  color: #374151;
}

.settings-nav-item.active {
  background: #dbeafe;
  color: #1d4ed8;
  border-right: 3px solid #1d4ed8;
}

.settings-nav-item .nav-icon {
  margin-right: 0.75rem;
  font-size: 1.1rem;
}

.settings-nav-item .nav-label {
  font-weight: 500;
}

.settings-main {
  flex: 1 1;
  padding: 2rem;
}

.settings-section {
  max-width: 600px;
}

.section-header {
  margin-bottom: 2rem;
}

.section-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
}

.section-header p {
  color: #6b7280;
  margin: 0;
}

/* Formulaire de mot de passe */
.password-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 500;
  color: #374151;
}

.form-group input {
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s ease;
}

.form-group input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-help {
  color: #6b7280;
  font-size: 0.875rem;
}

.form-actions {
  margin-top: 1rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.btn-primary:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

.message {
  padding: 1rem;
  border-radius: 8px;
  font-weight: 500;
}

.message.success {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.message.error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

/* Informations du profil */
.profile-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 8px;
}

.info-item label {
  font-weight: 500;
  color: #374151;
}

.info-item span {
  color: #6b7280;
}

/* Paramètres de notification */
.notification-settings {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f9fafb;
  border-radius: 8px;
}

.setting-info h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
}

.setting-info p {
  color: #6b7280;
  margin: 0;
  font-size: 0.875rem;
}

/* Toggle switch */
.toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.toggle input:checked + .toggle-slider {
  background-color: #3b82f6;
}

.toggle input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

/* Paramètres de sécurité */
.security-settings {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.security-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f9fafb;
  border-radius: 8px;
}

.security-info h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
}

.security-info p {
  color: #6b7280;
  margin: 0;
  font-size: 0.875rem;
}

/* Responsive */
@media (max-width: 768px) {
  .settings-content {
    flex-direction: column;
  }
  
  .settings-sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
  
  .settings-nav {
    display: flex;
    overflow-x: auto;
    padding: 0;
  }
  
  .settings-nav-item {
    flex-shrink: 0;
    border-right: 1px solid #e5e7eb;
    border-radius: 0;
  }
  
  .settings-nav-item.active {
    border-right: 1px solid #e5e7eb;
    border-bottom: 3px solid #1d4ed8;
  }
  
  .settings-main {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".settings-page {\n  padding: 2rem;\n  background: #f8fafc;\n  min-height: calc(100vh - 70px);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.settings-header {\n  margin-bottom: 2rem;\n}\n\n.settings-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 0.5rem 0;\n}\n\n.settings-header p {\n  color: #6b7280;\n  margin: 0;\n}\n\n.settings-content {\n  display: flex;\n  gap: 2rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  width: 100%;\n}\n\n.settings-sidebar {\n  width: 250px;\n  background: #f9fafb;\n  border-right: 1px solid #e5e7eb;\n}\n\n.settings-nav {\n  padding: 1rem 0;\n}\n\n.settings-nav-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n}\n\n.settings-nav-item:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.settings-nav-item.active {\n  background: #dbeafe;\n  color: #1d4ed8;\n  border-right: 3px solid #1d4ed8;\n}\n\n.settings-nav-item .nav-icon {\n  margin-right: 0.75rem;\n  font-size: 1.1rem;\n}\n\n.settings-nav-item .nav-label {\n  font-weight: 500;\n}\n\n.settings-main {\n  flex: 1;\n  padding: 2rem;\n}\n\n.settings-section {\n  max-width: 600px;\n}\n\n.section-header {\n  margin-bottom: 2rem;\n}\n\n.section-header h2 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.5rem 0;\n}\n\n.section-header p {\n  color: #6b7280;\n  margin: 0;\n}\n\n/* Formulaire de mot de passe */\n.password-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: #374151;\n}\n\n.form-group input {\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: border-color 0.2s ease;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-help {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.form-actions {\n  margin-top: 1rem;\n}\n\n.btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 1rem;\n}\n\n.btn-primary {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.btn-primary:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.btn-secondary:hover {\n  background: #e5e7eb;\n}\n\n.message {\n  padding: 1rem;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.message.success {\n  background: #d1fae5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n.message.error {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n}\n\n/* Informations du profil */\n.profile-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 8px;\n}\n\n.info-item label {\n  font-weight: 500;\n  color: #374151;\n}\n\n.info-item span {\n  color: #6b7280;\n}\n\n/* Paramètres de notification */\n.notification-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.setting-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  background: #f9fafb;\n  border-radius: 8px;\n}\n\n.setting-info h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.25rem 0;\n}\n\n.setting-info p {\n  color: #6b7280;\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n/* Toggle switch */\n.toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n}\n\n.toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\n.toggle input:checked + .toggle-slider {\n  background-color: #3b82f6;\n}\n\n.toggle input:checked + .toggle-slider:before {\n  transform: translateX(26px);\n}\n\n/* Paramètres de sécurité */\n.security-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.security-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  background: #f9fafb;\n  border-radius: 8px;\n}\n\n.security-info h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.25rem 0;\n}\n\n.security-info p {\n  color: #6b7280;\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .settings-content {\n    flex-direction: column;\n  }\n  \n  .settings-sidebar {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n  }\n  \n  .settings-nav {\n    display: flex;\n    overflow-x: auto;\n    padding: 0;\n  }\n  \n  .settings-nav-item {\n    flex-shrink: 0;\n    border-right: 1px solid #e5e7eb;\n    border-radius: 0;\n  }\n  \n  .settings-nav-item.active {\n    border-right: 1px solid #e5e7eb;\n    border-bottom: 3px solid #1d4ed8;\n  }\n  \n  .settings-main {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
